// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"c820ef6a","412":"d3f46256","685":"054d0fb0","820":"e9268408","875":"5ad32501"}[chunkId] + ".chunk.js";
};